import React, { useEffect, useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useNavigate, useParams } from 'react-router-dom'
import Editor from 'components/editor'
import { Button, Checkbox, FormControlLabel, Stack } from '@mui/material'
const EditModal = ({ data, handleRefresh, category }) => {
  const AppService = useAppServices()
  const [openEditProduct, setOpenEditProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [svgIcon, setSvgIcon] = useState(null)
  const [description, setDescription] = useState(data.description)
  const uploadImage = useUploadImage()
  const { page_id, type } = useParams()

  // const [category, setCategory] = useState([])

  // const getCategories = async () => {
  //   const { response } = await AppService.onboardlistcategory.get({
  //     toaster: false,
  //   })
  //   if (response) {
  //     setCategory(response.data)
  //   } else {
  //     setCategory([])
  //   }
  // }

  console.log(page_id, 'params1212')
  const handleModal = () => {
    setOpenEditProduct(true)
  }

  const closeEditProduct = () => {
    setOpenEditProduct(false)
  }

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0])
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)
    let image_response = data.image
    if (e.target?.image?.files?.[0]) {
      const { response } = await uploadImage({
        file: e.target?.image?.files?.[0],
        desiredPath: `app/logo/image`,
      })
      if (response) {
        image_response = response.data
      }
    }

    const payload = {
      _id: data._id,
      name: e.target.name.value,
      description,
      image: image_response,
      video_path: e.target.video_path.value,
      page_path: e.target.page_path.value,
      type: type,
      status: e.target.status.value,
      points: e.target.points.value,
      category_id: page_id,
      custom_buttons: e.target.custom_buttons.checked,
    }

    console.log(payload, 'payload')

    const { response } = await AppService.onboarding_list.update({ payload })
    console.log(response, 'response')

    if (response) {
      setProcessing(false)
      closeEditProduct()
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={style}
            encType="multipart/form-data"
          >
            <MDTypography variant="h5" mb={2}>
              Edit Onboarding
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} data={description} />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Category</MDTypography>
              <MDInput
                defaultValue={data?.category_id?._id}
                select
                name="category"
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select a category</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </MDInput>
            </MDBox> */}

            {/* <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput
                select
                name="type"
                fullWidth
                required
                SelectProps={{ native: true }}
                defaultValue={data.type}
              >
                <option value="location">Location</option>
                <option value="agency">Agency</option>
                <option value="levelupmarketplace">LevelUpMarketplace</option>
              </MDInput>
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Points</MDTypography>
              <MDInput label="Points" name="points" fullWidth defaultValue={data.points} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography
                variant="button"
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <p>Page Path</p>

                <FormControlLabel
                  control={<Checkbox name="custom_buttons" defaultChecked={data.custom_buttons} />}
                  label="Custom Buttons"
                />
              </MDTypography>

              <MDInput
                label="Page Path"
                name="page_path"
                fullWidth
                required
                defaultValue={data.page_path}
              />
            </MDBox>

            {/* <MDBox mb={2} display="flex" flexDirection="column" gap={1}>
              <MDTypography variant="button" fontWeight="bold">
                SVG Icon
              </MDTypography>
              <input
                type="file"
                accept=".svg"
                name="svg_icon"
                onChange={handleSvgUpload}
                style={{
                  padding: "8px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  background: "#f9f9f9",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              />
            </MDBox> */}

            <MDBox mb={2}>
              <MDTypography variant="button">Video Path</MDTypography>
              <MDInput
                label="Video Path"
                name="video_path"
                fullWidth
                required
                defaultValue={data.video_path}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput
                select
                name="status"
                fullWidth
                required
                SelectProps={{ native: true }}
                defaultValue={data.status}
              >
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </MDInput>
            </MDBox>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal
